
import React, { useEffect, useState } from 'react';

const MultiselectCheckbox = (props) => {

  const [data, setData] = React.useState(null);

  const all = () => {
    const newData = [...data];
    data.map((item, index) => {
      newData.splice(index, 1, {        
        sn: data[index].sn,
        checked: !data[index].checked,
        snStatus: props.okOrNok
      });
    });
    setData(newData);
    props.onChange(newData.filter(x => x.checked));
  }

  const toggle = index => {
    const newData = [...data];
    newData.splice(index, 1, {
      
      sn: data[index].sn,
      checked: !data[index].checked,
      snStatus: props.okOrNok
    });
    setData(newData);
    props.onChange(newData.filter(x => x.checked));
  };


  useEffect(() => {      
    setData(props.options);    
  }, [props.options])
  

  return (
    <>
      <label>
            <input
              readOnly
              type="checkbox"              
              onClick={() => all()}
              style={{marginRight: 10}}
            />
            All
      </label>


      {data ? data.map((item, index) => (
         <div class="row">
            <div className="col-12 col-sm-12 col-lg-12">
                <label key={item.sn}>
                  <input
                    readOnly
                    type="checkbox"
                    checked={item.checked || false}
                    onClick={() => toggle(index)}
                    style={{marginRight: 10}}
                  />
                  {item.sn}
                </label>
            </div>
        </div>
      )) : ''}


     
    </>
  );
};


export default MultiselectCheckbox;